import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "xmp-classes"
    }}>{`XMP Classes`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPConst.md"
        }}>{`XMPConst`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPDateTime.md"
        }}>{`XMPDateTime`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPFile.md"
        }}>{`XMPFile`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPFileInfo.md"
        }}>{`XMPFileInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPIterator.md"
        }}>{`XMPIterator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPMeta.md"
        }}>{`XMPMeta`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPPacketInfo.md"
        }}>{`XMPPacketInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPProperty.md"
        }}>{`XMPProperty`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMPUtils.md"
        }}>{`XMPUtils`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      